import axios from 'axios';
import { SERVICE_URL } from '@/store/_commons';

// ----------------------------
// Lookup (Categories + Types)
// TODO: rename to categoryTypes

const namespaced = true;

const state = {
  allVisitCategories: [],
  allVisitTypes: [],
};

const mutations = {
  setState(state, payload) {
    state[payload.property] = payload.value;
  },
};

const actions = {
  /**
   * Set all available visit categories and types in store.
   * @param context
   * @returns {Promise<void>}
   */
  async setVisitData(context) {
    await context.dispatch('setVisitCategories');
    await context.dispatch('setVisitTypes');
  },

  /**
   * Set all available visit categories in store.
   * @param context
   */
  async setVisitCategories({ commit }) {
    const endpoint = `${SERVICE_URL}lookup/visitcategories`;

    try {
      const result = await axios.get(endpoint);
      commit('setState', { property: 'allVisitCategories', value: result.data });
    } catch (error) {
      console.error(error);
    }
  },

  /**
   * Set all available visit types in store.
   * @param context
   */
  async setVisitTypes({ commit }) {
    const endpoint = `${SERVICE_URL}lookup/visittypes`;

    try {
      const result = await axios.get(endpoint);
      commit('setState', { property: 'allVisitTypes', value: result.data });
    } catch (error) {
      console.error(error);
    }
  },

};

const getters = {
  lookupStoreData: state => ({
    allVisitCategories: state.allVisitCategories,
    allVisitTypes: state.allVisitTypes,
  })
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
}
